'use client';

import {
  Price,
  SimpleBlock,
  SimpleCard,
  Text,
} from '@soluto-private/mx-asurion-ui-react';

type CardsUIProps = {
  imageUrl: string;
  imageTitle: string;
  heading?: string;
  bodyText?: string;
  link?: string;
  footerPrice?: string;
  priceSupportiveText: string;
  isBenefitIncluded?: boolean;
};

export function CardsUI(props: CardsUIProps) {
  return (
    <SimpleCard href={props.link ?? ''} className="h-360px w-381px">
      <SimpleCard.Image height="200px" width="381">
        <img alt={props.imageTitle} src={props.imageUrl} />
      </SimpleCard.Image>
      <SimpleBlock className="h-160px w-381px">
        <SimpleBlock.Heading headingLevel="h1" className="pt-4">
          {props.heading}
        </SimpleBlock.Heading>
        <Text color="#5D5E61" size={1}>
          {props.bodyText}
        </Text>
        <Price>
          <Price.Cost>{props.footerPrice}</Price.Cost>
          {!props.isBenefitIncluded && (
            <Price.SupportiveText>
              {props.priceSupportiveText}
            </Price.SupportiveText>
          )}
          {props.isBenefitIncluded && (
            <Price.SupportiveText className="line-through">
              {props.priceSupportiveText}
            </Price.SupportiveText>
          )}
        </Price>
      </SimpleBlock>
    </SimpleCard>
  );
}
